import { Paragraph, SizableText, SmartLink, Stack, XStack, YStack, shadowStandard } from '@my/ui'
import { BlockTitle } from 'app/components'
import { RedeemOfferButton, SaveOfferButton } from 'app/features/offer/containers'
import { BrandFeaturedOfferBlock } from './brand-featured-offer.block'
import { SolitoImage } from 'solito/image'

export const BrandFeaturedOfferComponent = (block: BrandFeaturedOfferBlock) => {
  if (!block.offer) return null

  return (
    <YStack position="relative" flex={1} height="100%" gap="$4">
      {block.title && <BlockTitle>{block.title}</BlockTitle>}
      <YStack position="relative" flex={1} height="100%">
        <XStack zIndex={10} position="absolute" top="$3.5" right="$3.5">
          <SaveOfferButton
            size={32}
            offerId={block.offer.id}
            isBookmarked={block.offer.isBookmarked}
          />
        </XStack>

        <YStack br="$3" overflow="hidden" bg="$white" flex={1} {...shadowStandard}>
          <YStack flex={1} $gtMd={{ flexDirection: 'row-reverse' }}>
            <SmartLink
              Component={YStack}
              tabIndex={-1}
              href={`/discounts/${block.offer.brand.slug}/${block.offer.slug}`}
              flex={1}
              $gtMd={{ width: '50%' }}
              pressStyle={{
                opacity: 0.85,
              }}
              hoverStyle={{
                opacity: 0.95,
              }}
            >
              {block.offer.featuredImage && (
                <Stack
                  overflow="hidden"
                  aspectRatio={1}
                  $gtXs={{ aspectRatio: 16 / 9 }}
                  $gtMd={{ aspectRatio: 1 }}
                >
                  <SolitoImage
                    src={block.offer.featuredImage.url}
                    alt={block.offer.featuredImage.alt}
                    sizes="(max-width: 900px) 100vw, 446px"
                    fill
                    contentFit="cover"
                  />
                </Stack>
              )}
            </SmartLink>

            <YStack
              flex={1}
              mt="$-10"
              gap="$3.5"
              p="$3.5"
              $gtSm={{ p: '$6' }}
              $gtMd={{ width: '50%', mt: 0 }}
            >
              <SmartLink
                Component={Stack}
                href={`/discounts/${block.offer.brand.slug}/${block.offer.slug}`}
                flexGrow={1}
                pressStyle={{
                  opacity: 0.9,
                }}
                hoverStyle={{
                  opacity: 0.95,
                }}
              >
                <YStack
                  mb="$3.5"
                  mx="auto"
                  br="$2"
                  bc="$white"
                  boc="$white"
                  bw="$2"
                  alignSelf="flex-start"
                  $gtMd={{ m: 0, mb: '$3.5' }}
                  {...shadowStandard}
                >
                  <SolitoImage
                    src={block.offer.brand.logo.url}
                    alt={block.offer.brand.logo.alt || ''}
                    contentFit="contain"
                    width={88}
                    height={88}
                    style={{ borderRadius: 4, backgroundColor: 'white' }}
                  />
                </YStack>

                <SizableText
                  mt="auto"
                  numberOfLines={3}
                  size="$6"
                  fow="800"
                  ta="center"
                  $gtXs={{ size: '$8', fow: '800' }}
                  $gtMd={{ ta: 'left' }}
                >
                  {block.offer.name}
                </SizableText>
                <Paragraph
                  size="$3"
                  numberOfLines={3}
                  color="$overlay11"
                  pt="$3"
                  ta="center"
                  $gtXs={{ size: '$5' }}
                  $gtMd={{ ta: 'left' }}
                >
                  {block.offer.description}
                </Paragraph>
              </SmartLink>

              {block.offer.redeemInList && (
                <RedeemOfferButton
                  offer={block.offer}
                  isEmbed={block.isEmbedded}
                  buttonProps={{
                    h: 48,
                    $gtSm: {
                      maxWidth: '100%',
                    },
                  }}
                  $gtSm={{
                    mt: 'auto',
                  }}
                />
              )}
            </YStack>
          </YStack>
        </YStack>
      </YStack>
    </YStack>
  )
}
